import React, { useState, useMemo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Box, Grid, Button, SectionTitle } from '@blueprint/ui';
import CustomerLogo from '../../CustomerLogo/CustomerLogo';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import { axiosInstance } from '../../../functions/axios';

import AccountHistoryTableComponent from '../../Table/AccountHistoryTableComponent';

const StyledGrid = styled(Grid)`
    padding-top: 100px;
    padding-right: 5vw;
    padding-left: 5vw;
    padding-bottom: 5em;
`;

const AccountHistoryTable = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [cursor, setCursor] = useState('default');
    const [accountHistoryData, setAccountHistoryData] = useState([]);
    const globalState = useSelector((state) => state);
    const emailId = useSelector((state) => state.beneDetails.details.emailId);
    const isRegisteredUser = useSelector((state) => state.beneDetails.registeredUser);
    const footerHeight = globalState.beneDetails.footerHeight;
    const PAYMENT_LIST = process.env.REACT_APP_PAYMENT_LIST;
    const PAYMENT_HISTORY = process.env.REACT_APP_PAYMENT_HISTORY;
    const FETCH_ACCOUNT_HISTORY = process.env.REACT_APP_FETCH_ACCOUNT_HISTORY;
    const [fetchCount, setFetchCount] = useState(0);

    useEffect(() => {
        if (!globalState.beneDetails.details.isLogged) {
            history.push('/');
        }
    }, [globalState, history]);

    const [dates, setDates] = useState({ fromDate: '', toDate: '' });
    useEffect(() => {
        const fetchAccountHistory = async () => {
            try {
                const response = await axiosInstance.post(
                    FETCH_ACCOUNT_HISTORY,
                    JSON.stringify({
                        fromDate: dates.fromDate,
                        toDate: dates.toDate,
                    })
                );

                const responseJSON = response.data;
                console.log('Logging FETCH_ACCOUNT_HISTORY response', responseJSON);
                setAccountHistoryData(responseJSON);
            } catch (error) {
                console.log('Logging FETCH_ACCOUNT_HISTORY error', error);
            }
        };
        fetchAccountHistory();
    }, [FETCH_ACCOUNT_HISTORY, dates, fetchCount]);

    const fetchAccountsAgain = () => {
        setFetchCount((fetchCount) => fetchCount + 1);
        console.log('Fetching Accounts again');
    };

    useEffect(() => console.log('New fetch count is', fetchCount), [fetchCount]);

    const data = useMemo(() => accountHistoryData, [accountHistoryData]);
    const columns = useMemo(() => {
        const tableAccessorArray = [
            {
                accessor: 'bankAccount.accountNumber',
                label: 'accountNumber',
            },
            {
                accessor: 'bankAccount.bankClearingCode',
                label: 'bankClearingCode',
            },
            {
                accessor: 'bankAccount.ibanAccountNumber',
                label: 'ibanAccountNumber',
            },
            {
                accessor: 'bankAccount.bankBic',
                label: 'bic',
            },
            {
                accessor: 'wallet.walletAccountValue',
                label: 'walletAccountValue',
            },
            {
                accessor: 'countryCode',
                label: 'countryCode',
            },
        ];

        const accountHistoryColumns = tableAccessorArray.map((column) => {
            let columnDisplayText = t(`accountHistory.${column.label}`);
            return { ...column, Header: columnDisplayText };
        });
        return accountHistoryColumns;
    }, [t]);

    return (
        <StyledGrid container role='main' style={{ paddingBottom: `${footerHeight + 20}px` }}>
            <CustomerLogo />
            <Grid item xs={12}>
                <Box>
                    <SectionTitle variant='h1' className='page-title' tabIndex='-1' marginBottom={4}>
                        {t('accountHistory.accountHistory')}
                    </SectionTitle>
                </Box>
            </Grid>
            {isRegisteredUser ? (
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm='auto'>
                            <Box marginBottom={['10px', '10px', '10px', '10px']}>
                                <Button
                                    id='button-payment-list'
                                    variant='light.tertiary'
                                    onClick={() => {
                                        history.push(PAYMENT_LIST);
                                    }}
                                >
                                    {t('accountHistory.paymentList')}
                                </Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm='auto'>
                            <Box marginBottom={['10px', '10px', '10px', '10px']}>
                                <Button
                                    id='button-payment-history'
                                    variant='light.tertiary'
                                    onClick={() => {
                                        history.push(PAYMENT_HISTORY);
                                    }}
                                >
                                    {t('accountHistory.paymentHistory')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            ) : null}
            <Grid container>
                <AccountHistoryTableComponent data={data} columns={columns} fetchAccountsAgain={fetchAccountsAgain} id='pl-table-paymentsList' />
            </Grid>
        </StyledGrid>
    );
};

export default AccountHistoryTable;
